var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "filepicker",
      staticClass: "filepicker",
      class: _vm.classes,
      attrs: { id: "filepicker" },
    },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("div", { staticClass: "filemanager-header header" }, [
            _c(
              "h1",
              { staticClass: "filemanager-title header-title" },
              _vm._l(_vm.path, function (folder, index) {
                return _c("div", [
                  _vm.path.length !== index + 1
                    ? _c(
                        "span",
                        {
                          staticClass: "filemanager-title-clickable",
                          on: {
                            click: function ($event) {
                              return _vm.openFolder(folder)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(folder.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _c("span", [_vm._v(_vm._s(folder.name))]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _vm.dropzone
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary header-btn-add",
                    attrs: { type: "button", id: "upload-files-button" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "me-1",
                        attrs: {
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(
                      "\n\n                " +
                        _vm._s(_vm.$t("Upload files")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          this.modal
            ? _c(
                "button",
                {
                  staticClass: "filemanager-btn-close",
                  attrs: { type: "button" },
                  on: { click: _vm.closeModal },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 1792 1792",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btn-toolbar mb-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-light me-2",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.newFolder(_vm.folder.id)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "me-1 text-muted",
                    attrs: {
                      width: "1em",
                      height: "1em",
                      viewBox: "0 0 16 16",
                      fill: "currentColor",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        d: "M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z",
                      },
                    }),
                  ]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("New folder")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group btn-group-sm me-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light dropdown-toggle",
                  attrs: {
                    type: "button",
                    id: "dropdown-action-button",
                    "data-bs-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "true",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("Action")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "dropdown-action-button" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        type: "button",
                        disabled: _vm.selectedItems.length === 0,
                      },
                      on: { click: _vm.deleteSelected },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Delete")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.folder.id || _vm.selectedFiles.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.moveToParentFolder()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Move to parent folder")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { type: "button", disabled: "disabled" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$tc(
                              "# items selected",
                              _vm.selectedItems.length,
                              {
                                count: _vm.selectedItems.length,
                              }
                            )
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group btn-group-sm" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  class: { active: _vm.view === "grid" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.switchView("grid")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "text-muted",
                      attrs: {
                        width: "1em",
                        height: "1em",
                        viewBox: "0 0 16 16",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("Grid")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  class: { active: _vm.view === "list" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.switchView("list")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "text-muted",
                      attrs: {
                        width: "1em",
                        height: "1em",
                        viewBox: "0 0 16 16",
                        fill: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("List")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center ms-2" }, [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "spinner-border spinner-border-sm text-secondary",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "visually-hidden" }, [
                        _vm._v(_vm._s(_vm.$t("Loading…"))),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.dropzone
            ? _c("vue-dropzone", {
                ref: "dropzone",
                attrs: { id: "dropzone", options: _vm.dropOptions },
                on: {
                  "vdropzone-success": _vm.dropzoneSuccess,
                  "vdropzone-sending": _vm.dropzoneSending,
                  "vdropzone-complete": _vm.dropzoneComplete,
                  "vdropzone-error": _vm.dropzoneError,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filemanager-list",
              class: { "filemanager-view-list": _vm.view === "list" },
              on: {
                click: function ($event) {
                  return _vm.checkNone()
                },
              },
            },
            _vm._l(_vm.filteredItems, function (item) {
              return _c(
                "div",
                {
                  staticClass:
                    "filemanager-item filemanager-item-with-name filemanager-item-editable",
                  class: {
                    "filemanager-item-selected":
                      _vm.selectedItems.indexOf(item) !== -1,
                    "filemanager-item-folder": item.type === "f",
                    "filemanager-item-file": item.type !== "f",
                    "filemanager-item-dragging-source":
                      _vm.dragging && _vm.selectedItems.indexOf(item) !== -1,
                  },
                  attrs: { id: "item_" + item.id, draggable: "true" },
                  on: {
                    click: function ($event) {
                      return _vm.check(item, $event)
                    },
                    drop: function ($event) {
                      return _vm.drop(item, $event)
                    },
                    dragstart: function ($event) {
                      return _vm.dragStart(item, $event)
                    },
                    dragover: function ($event) {
                      return _vm.dragOver($event)
                    },
                    dragenter: function ($event) {
                      return _vm.dragEnter($event)
                    },
                    dragleave: function ($event) {
                      return _vm.dragLeave($event)
                    },
                    dragend: function ($event) {
                      return _vm.dragEnd($event)
                    },
                    dblclick: function ($event) {
                      return _vm.onDoubleClick(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "filemanager-item-wrapper" }, [
                    item.type === "i"
                      ? _c("div", { staticClass: "filemanager-item-icon" }, [
                          _c(
                            "div",
                            { staticClass: "filemanager-item-image-wrapper" },
                            [
                              _c("img", {
                                staticClass: "filemanager-item-image",
                                attrs: {
                                  src: item.thumb_sm,
                                  alt: item.alt_attribute_translated,
                                },
                              }),
                            ]
                          ),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "filemanager-item-icon",
                            class: "filemanager-item-icon-" + item.type,
                          },
                          [
                            item.type === "a"
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "bi bi-file-earmark-music",
                                    attrs: {
                                      width: "80px",
                                      height: "80px",
                                      viewBox: "0 0 16 16",
                                      fill: "currentColor",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        "fill-rule": "evenodd",
                                        d: "M9.757 5.67A1 1 0 0 1 11 6.64v1.75l-2 .5v3.61c0 .495-.301.883-.662 1.123C7.974 13.866 7.499 14 7 14c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 11.134 6.501 11 7 11c.356 0 .7.068 1 .196V6.89a1 1 0 0 1 .757-.97l1-.25z",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.type === "v"
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "bi bi-file-earmark-play-fill",
                                    attrs: {
                                      width: "80px",
                                      height: "80px",
                                      viewBox: "0 0 16 16",
                                      fill: "currentColor",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "fill-rule": "evenodd",
                                        d: "M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.type === "d"
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "bi bi-file-earmark",
                                    attrs: {
                                      width: "80px",
                                      height: "80px",
                                      viewBox: "0 0 16 16",
                                      fill: "currentColor",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.type === "f"
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "bi bi-folder",
                                    attrs: {
                                      width: "80px",
                                      height: "80px",
                                      viewBox: "0 0 16 16",
                                      fill: "currentColor",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M9.828 4a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 6.173 2H2.5a1 1 0 0 0-1 .981L1.546 4h-1L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3v1z",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        "fill-rule": "evenodd",
                                        d: "M13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zM2.19 3A2 2 0 0 0 .198 5.181l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H2.19z",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "filemanager-item-name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "filemanager-item-editable-button",
                        attrs: { href: "/admin/files/" + item.id + "/edit" },
                      },
                      [
                        _c("span", {
                          staticClass: "filemanager-item-editable-button-icon",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v(_vm._s(_vm.$t("Edit"))),
                        ]),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.options.multiple
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-success filemanager-btn-add btn-add-multiple",
                  attrs: {
                    type: "button",
                    id: "add-selected-files-button",
                    disabled: _vm.selectedFiles.length < 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addSelectedFiles()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Add selected files")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.options.single
            ? _c(
                "button",
                {
                  staticClass:
                    "btn btn-success filemanager-btn-add btn-add-single",
                  attrs: {
                    type: "button",
                    id: "add-selected-file-button",
                    disabled: _vm.selectedFiles.length !== 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addSingleFile(_vm.selectedFiles[0])
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("Add selected file")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }